import React, { useEffect, useRef, useState } from 'react';
import { setupMaps } from '../../../modules/map';
import LoadingSpinner from '../LoadingSpinner';
import usePlaces from './hooks/usePlaces';
import Place from './elements/Place';

const Places = () => {
  const ref = useRef(null);
  const mapRef = useRef(null);

  const {
    waiting,
    places,
    currentPlace,
    setCurrentPlace,
    start,
    setupMap,
    setSetupMap,
  } = usePlaces(ref?.current?.parentNode?.dataset?.id);

  useEffect(() => {
    if (!waiting && !setupMap) {
      console.log(`Places: ${JSON.stringify(places)}`);
      setupMaps(mapRef.current, {
        key: 'AIzaSyCt1YfF8ExNd902cFWca7yTflrxbjaFEAI',
        options: {
          zoom: Number(places.center.zoom),
          zoomControl: false,
          fullscreenControl: false,
          center: {
            lat: places.center.lat,
            lng: places.center.lng,
          },
          clickableMarkers: true,
          markers: places.places.map((place) => ({
            target: '#example1',
            lat: place.lat,
            lng: place.lng,
            label: place.title,
            callback: () => setCurrentPlace(place),
            icon: `${ASSET_DIR}/images/marker.svg`,
          })),
        },
      });

      setSetupMap(true);
    }
  }, [mapRef.current]);

  return (
    <div className="c-places o-wrapper o-wrapper--wide" ref={ref}>
      {waiting ? (
        <LoadingSpinner />
      ) : (
        <>
          <div className="c-places__list">
            {places.places.map((place) => (
              <Place
                payload={place}
                active={place.id === currentPlace.id}
                key={`place-link--${place.id}`}
              />
            ))}
          </div>

          <div className="c-places__map-wrapper">
            <div
              className="c-places__map o-map js-map"
              id="placesMap"
              ref={mapRef}
            ></div>
          </div>

          <div className="c-places__description u-hidden-until@tablet-wide">
            <h4
              className="c-places__description__title"
              dangerouslySetInnerHTML={{ __html: currentPlace.title }}
            ></h4>

            <p
              className="c-places__description__text"
              dangerouslySetInnerHTML={{ __html: currentPlace.description }}
            ></p>

            <p className="c-places__description__explore">
              <a
                className="o-btn o-btn--more o-btn--purple"
                href={currentPlace.url}
                title={currentPlace.title}
              >
                Explore More
              </a>
            </p>

            <div className="c-places__description__image">
              <img src={currentPlace.image} alt={currentPlace.title} />
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Places;
